// extracted by mini-css-extract-plugin
module.exports = {"input":"SearchBox_input__1Muh3","searchIcon":"SearchBox_searchIcon__KRhT5","inputWithValueMobile":"SearchBox_inputWithValueMobile__lU6O5"};